import { createStore } from "vuex";
import axios from "axios";
import { Toast } from "vant";
import useShare from "@/composiables/useShare.js";

axios.defaults.withCredentials = true;

const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true,
  });
};

export default createStore({
  state: {
    newsList: {},
    slideList: {},
    categoryList: [],
    selectedCategoryId: 0,
  },
  mutations: {
    initNewsList(state, { categoryId, list }) {
      state.newsList[categoryId] = list;
    },
    addNewsList(state, { categoryId, list }) {
      const prevList = state.newsList[categoryId] || [];
      state.newsList[categoryId] = prevList.concat(list);
    },
    updateCategory(state, categoryList) {
      state.categoryList = categoryList;
      console.log("updateCategory", categoryList);
    },
    updateSelectedCategoryId(state, categoryId) {
      state.selectedCategoryId = categoryId;
    },
    updateSlideList(state, { categoryId, list }) {
      state.slideList[categoryId] = list;
    },
  },
  actions: {
    getCategory({ commit }) {
      let categoryID = 0;
      let hash = window.location.hash;
      if (hash.includes("?") && hash.includes("=")) {
        categoryID = hash.split("?")[1].split("&")[0].split("=")[1];
      }
      axios
        .get(process.env.VUE_APP_BASE_URL + "/api/plus-info/diamondAreaList", {
          params: { categoryId: categoryID },
        })
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            let categoryList = data.data;
            if (data.code === 0) {
              categoryList.unshift({
                name: "首页",
                redirectCategoryId: categoryID,
                redirectType: "3",
              });
              commit("updateCategory", categoryList);
            } else {
              tip("网络错误，请重试");
            }
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch((error) => {
          console.log(error);
          tip("网络错误，请重试");
        });
    },

    getNewsList({ commit }, { params, loading, finished, refreshing }) {
      let categoryID = 0;
      let hash = window.location.hash;
      if (hash.includes("?") && hash.includes("=")) {
        categoryID = hash.split("?")[1].split("&")[0].split("=")[1];
      }
      return axios
        .get(process.env.VUE_APP_BASE_URL + "/api/plus-info/mobileList", {
          params: {
            ...params,
            shareCategoryId: categoryID,
          },
        })
        .then((res) => {
          if (refreshing.value) {
            refreshing.value = false;
          }
          loading.value = false;
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 0) {
              useShare({ id: categoryID, name: data.data.shareCategoryName });
              if (params.page == 1) {
                commit("initNewsList", {
                  categoryId: params.categoryId,
                  list: data.data.list,
                });
              } else {
                commit("addNewsList", {
                  categoryId: params.categoryId,
                  list: data.data.list,
                });
              }

              // 因为接口先分页后过滤，因此不能用pagesize来判断是否还有更多数据
              if (data.data.list.length <= 0) {
                finished.value = true;
              }
              commit("updateSlideList", {
                categoryId: params.categoryId,
                list: data.data.slideList,
              });
              return true;
            } else {
              tip("网络错误，请重试");
              finished.value = true;
              return false;
            }
          } else {
            tip("网络错误，请重试");
            finished.value = true;
            return false;
          }
        })
        .catch((error) => {
          console.log(error);
          if (refreshing.value) {
            refreshing.value = false;
          }
          loading.value = false;
          tip("网络错误，请重试");
          return false;
        });
    },
    search({ commit }, { params, loading, finished, refreshing }) {
      axios
        .get(process.env.VUE_APP_BASE_URL + "/api/zswork/search", {
          params: params,
        })
        .then((res) => {
          if (refreshing.value) {
            refreshing.value = false;
          }
          loading.value = false;
          if (res.status === 200) {
            const data = res.data;

            if (data.code === 0) {
              if (params.page == 1) {
                commit("initNewsList", {
                  categoryId: params.categoryId,
                  list: data.data.list,
                });
              } else {
                commit("addNewsList", {
                  categoryId: params.categoryId,
                  list: data.data.list,
                });
              }

              if (data.data.list.length < 5) {
                finished.value = true;
              }
            } else {
              tip("网络错误，请重试");
              finished.value = true;
            }
          } else {
            tip("网络错误，请重试");
            finished.value = true;
          }
        })
        .catch(() => {
          tip("网络错误，请重试");
        });
    },
  },
  modules: {},
});
